import dayjsTZ from "../../../../../utils/dayjs";

export const getMonthsOfYear = () => {
  let months = [];
  let startInstance = dayjsTZ().startOf("year");
  let len = dayjsTZ().diff(dayjsTZ(startInstance), "months", false);
  [...Array(len + 1)].map((x, idx) =>
    months.push({
      nr: idx + 1,
      muaji: dayjsTZ(startInstance).add(`${idx}`, "months").valueOf(),
      neto: "",
      bruto: "",
      taxes: "",
      totalCost: "",
    })
  );
  // console.log("start of year", startInstance.format("DD/MM/YYYY HH:MM"));
  // console.log("Months", months);
  return months;
};

export const getNextMonthsOfYear = (type, id) => {
  let months = [];
  let indicator = type === "next" ? id : 0;
  let startInstance =
    type === "next"
      ? dayjsTZ().startOf("year").add(5, "days")
      : dayjsTZ().startOf("year").subtract(id, "months");
  let len = dayjsTZ().diff(dayjsTZ(startInstance), "months", false);
  [...Array(len + 1 + indicator)].map((x, idx) =>
    months.push({
      nr: idx + 1,
      muaji: dayjsTZ(startInstance).add(`${idx}`, "months").valueOf(),
      neto: "",
      bruto: "",
      taxes: "",
      totalCost: "",
    })
  );
  // console.log("start of year", startInstance.format("DD/MM/YYYY HH:MM"));
  // console.log("Months", months);
  return months;
};

// export const netoFromBruto = (brutoAmount) => {
// 	if (brutoAmount > 0) {

// 	}

// }

// export const brutoFromNeto = () => {

// }
